module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "value-project-name",
    attrs: {
      "to": _vm.routeParams,
      "data-action": _vm.model + '.show',
      "data-action-id": _vm.item.id
    }
  }, [_c('div', {
    staticClass: "value-project-name--name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.item.lead_mask_name) ? _c('div', {
    staticClass: "value-project-name--lead-mask"
  }, [_vm._v(_vm._s(_vm.$t('models.project.lead_mask')) + ": " + _vm._s(_vm.item.lead_mask_name))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51fc93eb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueProjectName.vue
// module id = 1907
// module chunks = 0